import React from 'react';
import { Pressable, PressableProps, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';

import colors, { appTheme } from '@/config/colors';
import { Icon, IconName } from './Icon';

interface ButtonProps extends PressableProps {
  label: string;
  icon?: IconName;
  look?: keyof typeof looks;
}

const looks = {
  minimal: {
    wrapper: {
      backgroundColor: 'transparent',
    },
    text: {
      color: appTheme.textColor,
    },
  },
  default: {
    wrapper: {},
    text: {},
  },
  danger: {
    wrapper: {
      backgroundColor: colors.red,
    },
    text: {
      color: colors.white,
    },
  },
  dangerOutlined: {
    wrapper: {
      borderWidth: 1,
      borderColor: colors.red,
      backgroundColor: 'transparent',
    },
    text: {
      color: colors.red,
    },
  },
  neutral: {
    wrapper: {
      backgroundColor: colors.twGrey,
    },
    text: {
      color: appTheme.textColor,
    },
  },
  secondary: {
    wrapper: {
      backgroundColor: colors.white,
      borderWidth: 1,
      borderColor: appTheme.primary,
    },
    text: {
      color: appTheme.primary,
    },
  },
};

const primaryButtonStyles = StyleSheet.create({
  wrapper: {
    height: 48,
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    flexDirection: 'row',
    columnGap: 8,
    backgroundColor: appTheme.primary,
  },
  icon: {
    fontSize: 24,
    color: colors.white,
  },
  label: {
    fontWeight: '600',
    fontSize: 14,
    color: colors.white,
  },
});

export function PrimaryButton({
  label,
  look = 'default',
  icon,
  ...props
}: ButtonProps) {
  const iconStyle = {
    ...primaryButtonStyles.icon,
    ...looks[look].text,
  };

  return (
    <Pressable
      {...props}
      style={({ pressed }) => [
        { opacity: pressed ? 0.7 : 1 },
        props.disabled ? { opacity: 0.5, backgroundColor: colors.grey } : {},
      ]}
    >
      <View style={[primaryButtonStyles.wrapper, looks[look].wrapper]}>
        {icon ? <Icon style={iconStyle} name={icon} /> : null}
        <Text style={[primaryButtonStyles.label, , looks[look].text]}>
          {label}
        </Text>
      </View>
    </Pressable>
  );
}
